import { effectiveAspectRatio, ratiosMatch } from './effectiveAspectRatio';
import type { BannerLayout } from './types';

/**
 * 適用中のレイアウトで生成できない理由 (生成ボタンを止める・docs/features/banner-layout-template-plan.md §7)。問題が無ければ null。
 * - 実効比率がレイアウトの比率とずれた (BE の受付で 400 になる前に止める)
 *
 * 商品枠は「選択中の画像の何枚目か」を指すので、素材が無い・外れたことでは止めない (BE が枠を外す・§17)。
 */
export function getBannerLayoutIssue(
  layout: BannerLayout | null | undefined,
  settings: { aspect_ratio?: string | null; target_width?: number | null; target_height?: number | null },
): string | null {
  if (!layout) return null;
  const effective = effectiveAspectRatio(settings);
  if (!effective || !ratiosMatch(layout.aspectRatio, effective)) {
    return 'アスペクト比が変わったため、レイアウトを開き直して適用するか、レイアウトを外してください。';
  }
  return null;
}
